import { render, staticRenderFns } from "./ChartKingOfJordanProperties.vue?vue&type=template&id=7a80ba19&"
import script from "./ChartKingOfJordanProperties.vue?vue&type=script&lang=js&"
export * from "./ChartKingOfJordanProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ChartKingOfJordanProperties.vue?vue&type=custom&index=0&blockType=tsv"
if (typeof block0 === 'function') block0(component)

export default component.exports